// Latest firmware version the fleet should be on. Bump this on each release
// (match FIRMWARE_VERSION in WaterTankMonitor.ino). It's used only to detect a
// device that's mid- or pending-update so the UI can show an "updating" note —
// the version string itself is never shown to customers.
export const LATEST_FW = 'v8.5.5';

// True when a device's reported firmware is OLDER than LATEST_FW (i.e. it's
// about to / in the middle of updating over the air). Returns false when the
// version is unknown, equal, or somehow newer (so we never nag on a version we
// forgot to bump here).
export function isFirmwareUpdating(fw) {
  if (!fw || typeof fw !== 'string') return false;
  const parse = (v) => String(v).replace(/^v/i, '').split('.').map((n) => parseInt(n, 10) || 0);
  const a = parse(fw);
  const b = parse(LATEST_FW);
  for (let i = 0; i < 3; i++) {
    if ((a[i] || 0) !== (b[i] || 0)) return (a[i] || 0) < (b[i] || 0);
  }
  return false;
}
